<template>
  <div class="no-permission-container">
    <Icons name="NoAccessIcon" size="xl" class="no-access-icon" />
    <p>Mağaza hesabınızın bu sayfaya erişimi bulunmamaktadır.</p>
    <AppButton
      primary
      md
      title="Ana Sayfaya Git"
      :buttonStyle="{ width: '173px' }"
      @buttonClick="goToHome"
    />
  </div>
</template>

<script setup>
import { Icons, AppButton } from '@n11/so-ui-components';
import { useRouter } from 'vue-router';

const router = useRouter();

const goToHome = () => {
  router.push('/');
};
</script>

<style scoped lang="scss">
@import '@/assets/styles/variables.scss';

.no-permission-container {
  width: 100%;
  height: 770px;
  justify-content: center;
  text-align: center;
  display: flex;
  padding: 24px;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  align-self: stretch;
  border-radius: 8px;
  background: $colorN00;
  margin: 20px 0 20px 0;
  .no-access-icon {
    :deep(svg) {
      width: 120px;
      height: 120px;
    }
  }
  p {
    color: $colorN80;
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: -0.05px;
  }
}
</style>
